import { type MCPServerInfo } from '../../types';

const GoogleDriveServer: MCPServerInfo = {
  serverId: 'GOOGLE_DRIVE',
  name: 'Google Drive',
  slug: 'google-drive',
  description:
    'Google Drive MCP Server for searching, reading, creating, and managing files and permissions',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'https://github.com/natomalabs/google-mcp-servers',
    commitSha: '403a9f5b',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default GoogleDriveServer;
